import { ITour } from "../queries";
import { IToursFilter, ITopToursCategory } from "../types";

// TODO - split and maybe delete the strings value even if they would help in dev, they won't when it really matters. Enum is int most likely?
export enum EAppActionTypes {
	UpdateQuery = 'update_query',
	UpdateUser = 'update_user',
	ResetUser = 'reset_user',
	SetTour = 'set_tour',

	SetFilter = 'set_filter',
	ResetFilter = 'reset_filter',

	SetSelectedTopCategory = 'set_selected_top_category',
	SetSelectedCategories = 'set_selected_categories',
}

export interface IAppStoreAction {
	type: EAppActionTypes
	tour?: ITour | null
	filter?: IToursFilter
	selectedCategories?: number[]
	selectedTopCategory?: ITopToursCategory
}

export type AppStoreDispatchAction = (action: IAppStoreAction) => void